import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { PageContext } from '@blaze-shared/projects-domain';

import { pageContextActions } from '../+state/page-context.actions';

import { PageContextSessionStorageService } from './page-context-session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class PageContextCommandService {
  private readonly store = inject(Store);
  private readonly pageContextSessionStorage = inject(PageContextSessionStorageService);

  setPageContext(pageContext: PageContext): void {
    this.pageContextSessionStorage.addPageContext(pageContext);
    this.store.dispatch(pageContextActions.set({ pageContext }));
  }

  removePageContext(pageContextId: string): void {
    this.pageContextSessionStorage.removePageContext(pageContextId);
    this.store.dispatch(pageContextActions.remove({ pageContextId }));
  }

  setForOverlay(pageContext: PageContext): void {
    this.store.dispatch(pageContextActions.setForOverlay({ pageContext }));
  }

  initializeFromSessionStorage(pageContext: Record<string, PageContext>): void {
    this.store.dispatch(pageContextActions.initializeFromSessionStorage({ pageContext }));
  }

  markAsLoaded(): void {
    this.store.dispatch(pageContextActions.markAsLoaded());
  }
  initializationStart(): void {
    this.store.dispatch(pageContextActions.initializationStart());
  }

  reset(): void {
    this.store.dispatch(pageContextActions.reset());
  }
}
